"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var FlexLinkButton = function FlexLinkButton(_ref) {
  var text = _ref.text,
    position = _ref.position,
    url = _ref.url,
    openOnNewWindow = _ref.openOnNewWindow;
  var positionClass;
  switch (position) {
    case 'center':
      positionClass = 'text-center';
      break;
    case 'left':
      positionClass = 'text-left';
      break;
    case 'right':
      positionClass = 'text-right';
      break;
    default:
      positionClass = 'text-center';
  }
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    className: "wrap flex-link-button ".concat(positionClass)
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: text,
    link: url,
    external: openOnNewWindow
  }));
};
FlexLinkButton.propTypes = {
  text: _propTypes["default"].string,
  position: _propTypes["default"].string,
  url: _propTypes["default"].string,
  openOnNewWindow: _propTypes["default"].bool
};
FlexLinkButton.defaultProps = {
  text: 'Button',
  position: 'center',
  url: '/',
  openOnNewWindow: false
};
var _default = exports["default"] = FlexLinkButton;